<template>
    <POReceiving></POReceiving>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const POReceiving = defineAsyncComponent(() =>
    import("../../components/Logistics/POReceiving.vue")
);
export default {
    name: "Logistics_RequestList", //The name you are in should not equal the name of the component you are importing.
    components: { POReceiving, AuthLayout },
};
</script>